<div class="p-card" style="max-width: 600px">
    <div class="p-card-title p-mb-2 p-mt-4" style="font-weight: bold">
        👋 {{ currentUser.firstName }}, {{ 'home.onboardingProfile.startWithEssentials' | translate }}
    </div>
    <div class="p-card-subtitle p-mb-3">{{ 'home.onboardingProfile.knowEachOther' | translate }}</div>

    <app-user-infos-form [user]="currentUser"></app-user-infos-form>
</div>
